module.exports = __webpack_public_path__ + "img/placeholder.f8ac53b5.png";